<template>
  <div class="order-form">
    <el-form
      ref="form"
      :model="editForm"
      label-width="80px"
      size="mini"
      :rules="rules"
    >
      <el-form-item
        label="服务形式"
        prop="service_type"
      >
        <el-radio-group v-model="editForm.service_type">
          <el-radio
            v-for="item in serviceTypeList"
            :key="item"
            :label="item"
          >{{ item }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="服务项"
        prop="right_name"
      >
        {{ editForm.right_name }}
        <!-- <el-radio-group v-model="editForm.right_name">
          <el-radio
            v-for="item in serviceOptionList"
            :key="item"
            :label="item"
          >{{ item }}</el-radio>
        </el-radio-group> -->
      </el-form-item>
      <el-form-item
        label="服务时间"
        prop="service_time"
      >
        <div @click="showPicker = true">
          <span
            v-if="!editForm.service_time"
            class="color-gray"
          >
            点击选择时间
          </span>
          <span v-else>
            {{ editForm.service_time }}
          </span>
        </div>

        <!-- <el-radio-group v-model="editForm.right_name">
          <el-radio
            v-for="item in serviceOptionList"
            :key="item"
            :label="item"
          >{{ item }}</el-radio>
        </el-radio-group> -->
      </el-form-item>
      <!-- <van-field
        readonly
        clickable
        label-width="80px"
        label-align="right"
        name="datetimePicker"
        :value="editForm.service_time"
        label="服务时间"
        placeholder="点击选择时间"
        @click="showPicker = true"
      /> -->
      <van-popup
        v-model="showPicker"
        position="bottom"
        get-container="body"
      >
        <van-datetime-picker
          v-model="editForm.currentDate"
          type="datetime"
          :minDate="minDate"
          title="选择完整时间"
          @confirm="datetimeConfirm"
        />
      </van-popup>
      <el-form-item
        label="专家"
        prop="expert_name"
      >
        <el-input
          v-model="editForm.expert_name"
          placeholder="请输入专家姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button
          type="primary"
          @click="onSubmit"
        >提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import leXiang from "@/apis/leXiang/index.js";
import moment from "moment";
import { Message } from "element-ui";

export default {
  name: "FangaiEdit",
  props: {
    rightName: {
      default: "",
    },
    rightCode: {
      default: "",
    },
    userInfo: {
      default: "",
    },
  },
  data() {
    return {
      editForm: {},
      serviceTypeList: ["线上机构", "线上远程"],
      serviceOptionList: ["国内肿瘤专家咨询", "国内影像专家报告解读"],
      showPicker: false,
      rules: {
        service_type: [
          { required: true, message: "请选择服务形式", trigger: "change" },
        ],
        right_name: [
          { required: true, message: "请选择服务项", trigger: "change" },
        ],

        expert_name: [
          { required: true, message: "请输入专家姓名", trigger: "change" },
        ],
        service_time: [
          { required: true, message: "请选择服务时间", trigger: "change" },
        ],
      },
      minDate: new Date(),
    };
  },
  created() {
    // this.fangaixianServiceDataSearch();
  },
  methods: {
    datetimeConfirm(value) {
      console.log(value);
      this.editForm.service_time = moment(value).format("YYYY-MM-DD HH:mm");
      this.showPicker = false;
    },
    fangaixianServiceDataAdd() {},
    fangaixianServiceDataSearch() {
      const params = {
        work_id: this.$route.query.id,
      };
      leXiang.fangaixianServiceDataSearch(params).then((res) => {
        if (this.rightName) res.right_name = this.rightName;
        this.editForm = res;
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { editForm, $route } = this;
          if (!editForm.service_time) {
            Message({
              message: "请选择时间",
              type: "error",
            });
            return;
          }
          editForm.files = [];
          editForm.work_id = $route.query.id;
          editForm.right_code = this.rightCode;
          editForm.user_id = this.userInfo.user_id;
          leXiang.fangaixianServiceDataAdd(editForm).then((res) => {
            console.log(res);
            this.$emit("updateSuccess");
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-form {
  min-width: 350px;
  box-sizing: border-box;
}
</style>